var _rect, _rect2, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigCardGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1320,
    height: 520,
    viewBox: "0 0 1320 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4863_9316)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1320,
    height: 520,
    fill: "#2B1C4D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4863_9316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1320,
    height: 520
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1320,
    height: 520,
    fill: "#2B1C4D"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4863_9316)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4863_9316",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -556,
    y: -571,
    width: 2060,
    height: 1999
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-545.379 1427.56L1493.85 1427.56C1499.38 1427.56 1503.85 1423.08 1503.85 1417.56L1503.85 -560.192C1503.85 -565.715 1499.38 -570.192 1493.85 -570.192L-545.378 -570.192C-550.901 -570.192 -555.378 -565.715 -555.378 -560.192L-555.379 1417.56C-555.379 1423.08 -550.902 1427.56 -545.379 1427.56Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4863_9316)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4863_9316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-288.439 1048.7L622.6 1048.7C628.122 1048.7 632.6 1044.22 632.6 1038.7L632.6 209.183C632.6 203.66 628.123 199.183 622.6 199.183L-288.438 199.183C-293.961 199.183 -298.438 203.66 -298.438 209.183L-298.439 1038.7C-298.439 1044.22 -293.962 1048.7 -288.439 1048.7Z",
    fill: "#2B1C4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.587 916.808L1233.65 916.808C1239.17 916.808 1243.65 912.33 1243.65 906.808L1243.65 -11.0727C1243.65 -16.5956 1239.17 -21.0727 1233.65 -21.0727L247.587 -21.0727C242.064 -21.0727 237.587 -16.5956 237.587 -11.0728L237.587 906.808C237.587 912.33 242.064 916.808 247.587 916.808Z",
    fill: "#A180FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1366.86 1212.57L1366.86 23.4561C1366.86 17.9332 1362.39 13.4561 1356.86 13.4561L695.3 13.4561C689.778 13.4561 685.3 17.9333 685.3 23.4561L685.3 1212.57C685.3 1218.09 689.777 1222.57 695.3 1222.57L1356.86 1222.57C1362.39 1222.57 1366.86 1218.09 1366.86 1212.57Z",
    fill: "#DF39EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8411 448.087L946.399 448.087C951.922 448.087 956.399 443.61 956.399 438.087L956.4 -603.153C956.4 -608.675 951.923 -613.153 946.4 -613.153L30.842 -613.153C25.3191 -613.153 20.842 -608.675 20.842 -603.153L20.8412 438.087C20.8412 443.61 25.3183 448.087 30.8411 448.087Z",
    fill: "#A180FF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4863_9316",
    x: -673.438,
    y: -988.152,
    width: 2415.3,
    height: 2585.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 187.5,
    result: "effect1_foregroundBlur_4863_9316"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4863_9316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1320,
    height: 520,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCardGradient);
export default __webpack_public_path__ + "static/media/big-card-gradient.cc66b2365ab068f28e55831a2650ea94.svg";
export { ForwardRef as ReactComponent };